import { useRef } from "react";
import { Upload, X } from "lucide-react";

export function PhotoPicker({ label, files, onChange, testId, required = false }) {
  const inputRef = useRef();

  const addFiles = (e) => {
    const newFiles = Array.from(e.target.files || []);
    onChange([...files, ...newFiles]);
    e.target.value = "";
  };

  const remove = (index) => onChange(files.filter((_, i) => i !== index));

  return (
    <div>
      <p className="text-sm font-medium text-slate-700 mb-1.5">
        {label} {required && <span className="text-red-500">*</span>}
      </p>
      <div className="flex flex-wrap gap-2">
        {files.map((f, i) => (
          <div key={i} className="relative h-16 w-16">
            <img src={URL.createObjectURL(f)} alt={f.name} className="h-16 w-16 rounded object-cover border border-slate-200" />
            <button
              type="button"
              data-testid={`${testId}-remove-${i}`}
              onClick={() => remove(i)}
              className="absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full bg-slate-900 text-white flex items-center justify-center"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
        <button
          type="button"
          data-testid={testId}
          onClick={() => inputRef.current?.click()}
          className="h-16 w-16 rounded border-2 border-dashed border-slate-300 flex items-center justify-center text-slate-400 hover:border-amber-500 hover:text-amber-600 transition-colors"
        >
          <Upload className="h-5 w-5" />
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple hidden onChange={addFiles} />
    </div>
  );
}
